import React, { useState } from "react";
import DomainUseCaseCard, { DOMAIN_PAGE_STYLES } from "./domainUseCaseLayout";
import TelecomProcessFlow from "./TelecomProcessFlow";
import UseCaseIndexGrid from "./UseCaseIndexGrid";
import DomainSeoHelmet from "./DomainSeoHelmet";
import DomainHiddenSeoContent from "./DomainHiddenSeoContent";

import {
  TELECOM_DOMAIN_INTRO,
  TELECOM_GROUPS,
  TELECOM_USE_CASES_SEO,
  TELECOM_DOMAIN_FAQS,
  TELECOM_ITEM_LIST_JSONLD,
  TELECOM_BREADCRUMB_JSONLD,
  TELECOM_WEBPAGE_JSONLD,
  TELECOM_FAQ_JSONLD,
} from "../../data/telecomUseCases";


function UseCaseCard({ useCase }) {
  return (
    <DomainUseCaseCard
      useCase={useCase}
      flow={<TelecomProcessFlow useCaseId={useCase.id} />}
    />
  );
}

function GroupSection({ group }) {
  const cases = TELECOM_USE_CASES_SEO.filter((uc) => uc.groupId === group.id);
  if (!cases.length) return null;
  return (
    <section id={group.id} className="fin-section" aria-labelledby={`${group.id}-heading`}>
      <h2 id={`${group.id}-heading`}>{group.label}</h2>
      <div className="fin-list">{cases.map((uc) => <UseCaseCard key={uc.id} useCase={uc} />)}</div>
    </section>
  );
}

export default function TelecomDomainContent() {
  const [activeFilter, setActiveFilter] = useState("all");
  const visibleGroups = activeFilter === "all" ? TELECOM_GROUPS : TELECOM_GROUPS.filter((g) => g.id === activeFilter);
  return (
    <div className="fin-page">
      <DomainSeoHelmet
        intro={TELECOM_DOMAIN_INTRO}
        domainSlug="telecom-domain"
        useCaseCount={TELECOM_USE_CASES_SEO.length}
        groupCount={TELECOM_GROUPS.length}
        itemListJsonLd={TELECOM_ITEM_LIST_JSONLD}
        breadcrumbJsonLd={TELECOM_BREADCRUMB_JSONLD}
        faqJsonLd={TELECOM_FAQ_JSONLD}
        webPageJsonLd={TELECOM_WEBPAGE_JSONLD}
      />
      <style>{DOMAIN_PAGE_STYLES}</style>
      <header className="fin-hero">
        <div className="fin-hero-inner">
          <h1>{TELECOM_DOMAIN_INTRO.title}</h1>
          {TELECOM_DOMAIN_INTRO.content ? <p>{TELECOM_DOMAIN_INTRO.content}</p> : null}
        </div>
      </header>
      <UseCaseIndexGrid useCases={TELECOM_USE_CASES_SEO} groups={TELECOM_GROUPS} heading="Telecom Use Cases" onFilterChange={setActiveFilter} />
      <div className="fin-wrap">{visibleGroups.map((group) => <GroupSection key={group.id} group={group} />)}</div>

      <DomainHiddenSeoContent
        domainTitle={TELECOM_DOMAIN_INTRO.title}
        domainFaqs={TELECOM_DOMAIN_FAQS}
        useCases={TELECOM_USE_CASES_SEO}
      />
    </div>
  );
}

